import { iUIState } from "../../interfaces/interfaces";
import { tUIAction, eUIActionTypes} from "./UITypes";

const initialState: iUIState = {
	isInited: false,
	isChrRegistered: true,
	isOrderBookModalButtonsBlocked: false,
	isWrongNetwork: false,
	isPricesUpdating: false,
	provider: null,
}

export const UIReducer = ( state = initialState, action: tUIAction) : iUIState => {
	switch (action.type){

		case eUIActionTypes.CLEAR_STATE:
			return {
				...initialState,
				isInited: state.isInited
			}
		;

		case eUIActionTypes.SET_INITED:
			return {...state, isInited: true}
		;

		case eUIActionTypes.SET_IS_CHR_REGISTERED:
			return {...state, isChrRegistered: action.payload}
		;

		case eUIActionTypes.SET_IS_ORDER_BOOK_MODAL_BUTTONS_BLOCKED:
			return {...state, isOrderBookModalButtonsBlocked: action.payload}
		;

		case eUIActionTypes.SET_IS_WRONG_NETWORK:
			return {...state, isWrongNetwork: action.payload}
		;

		case eUIActionTypes.SET_IS_PRICES_UPDATING:
			return {...state, isPricesUpdating: action.payload}
		;

		case eUIActionTypes.SET_PROVIDER:
			// console.log('provider reducer', {...state, provider: action.payload})
			const new_state = {...state, provider: action.payload};
			return new_state
		;

		default: return state;
	}
}